import {lazy} from 'react';

export const ForgotPasswordContainerModalAsync = lazy(() => import('./ForgotPasswordContainerModal'));
